import * as React from 'react';
import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';
import { omitProps } from '../helpers/omitProps.js';

const InputWrapper = styled.div.withConfig({
    displayName: "styles__InputWrapper",
    componentId: "sc-1497c62d-0"
})`
    position: relative;
    color: ${(props)=>props.theme.colors.Foreground};
`;
const StyledInput = styled.div.withConfig({
    displayName: "styles__StyledInput",
    componentId: "sc-1497c62d-1"
})`
    display: flex;
    border-bottom: 2px solid ${(props)=>props.theme.colors["Level 4"]};
`;
const InputLabel = styled.label.withConfig({
    displayName: "styles__InputLabel",
    componentId: "sc-1497c62d-2"
})`
    position: absolute;
    top: ${({ active  })=>active ? "0px" : "18px"};
    left: 0;
    height: 12px;
    color: ${(props)=>props.theme.colors["Level 4"]};
    white-space: nowrap;
    pointer-events: none;
    user-select: none;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    ${(props)=>css(props.theme.typography.SmallCapsHeadline)}
`;
const InputComponent = ({ isMask , ...props })=>{
    if (isMask) {
        return /*#__PURE__*/ React.createElement(ReactInputMask, props);
    }
    return /*#__PURE__*/ React.createElement("input", props);
};
const InputField = styled(omitProps("withIconRight", "theme")(InputComponent)).withConfig({
    displayName: "styles__InputField",
    componentId: "sc-1497c62d-3"
})`
    padding: 16px 0 4px;
    width: 100%;
    line-height: 18px;
    color: inherit;
    border: 0;
    outline: transparent;
    background-color: transparent;
    box-sizing: border-box;

    ${(props)=>css(props.theme.typography.Paragraph)}

    &:focus ~ ${InputLabel} {
        top: 0px;
    }

    &:disabled {
        color: ${(props)=>props.theme.colors["Level 3"]};
    }
`;
const InputIcon = styled.span.withConfig({
    displayName: "styles__InputIcon",
    componentId: "sc-1497c62d-4"
})`
    align-self: flex-end;
    color: ${(props)=>props.theme.colors["Level 4"]};
`;
const TextBlockUnderInput = styled.span.withConfig({
    displayName: "styles__TextBlockUnderInput",
    componentId: "sc-1497c62d-5"
})`
    display: inline-block;
    margin-top: ${(props)=>props.theme.spacers.M};
    font-style: italic;
    font-weight: 500;
    font-size: 12px;
    line-height: 17.28px;
`;
const InputError = styled(TextBlockUnderInput).withConfig({
    displayName: "styles__InputError",
    componentId: "sc-1497c62d-6"
})`
    color: #f44336;
`;
const InputHelperText = styled(TextBlockUnderInput).withConfig({
    displayName: "styles__InputHelperText",
    componentId: "sc-1497c62d-7"
})`
    color: ${(props)=>props.theme.colors["Level 4"]};
`;

export { InputError, InputField, InputHelperText, InputIcon, InputLabel, InputWrapper, StyledInput };
